<template>
  <div class="row">
    <div class="left-column"></div>
    <div class="right-column">
      <div class="main-input-form-container">
        <div class="gemnote-logo">
          <img src="../assets/gemnote_logo_pebble.png" alt="logo" />
        </div>
        <template v-if="!token">
          <form @click.prevent>
            <h3>{{ $t('confirm-reset.ui.token-required') }}</h3>
            <p>
              {{ $t('confirm-reset.ui.to-receive') }}
              <strong>
                <router-link :to="{ name: 'resetpassword' }" class="link">{{
                  $t('confirm-reset.ui.reset-page')
                }}</router-link>
              </strong>
            </p>
          </form>
        </template>
        <template v-else>
          <section v-if="successResetPassword">
            <h3 class="success">Your password has been successfully reset.</h3>

            <div class="flex ">
              <button class="login" @click="$router.push('/login')">
                log into your account
              </button>
            </div>
          </section>

          <form v-else @click.prevent>
            <h3>{{ $t('confirm-reset.ui.enter-confirm') }}</h3>

            <p class="message">Please enter a new password.</p>

            <div class="form-group">
              <input
                :placeholder="$t('confirm-reset.ui.pwd-placeholder')"
                class="form-control"
                :class="{ form__input__error: $v.password.$error }"
                type="password"
                v-model="password"
                required
                @blur="$v.password.$touch()"
              />
            </div>

            <div class="form-group last">
              <input
                :placeholder="$t('confirm-reset.ui.retype-pwd-placeholder')"
                class="form-control"
                :class="{ form__input__error: $v.reTypePassword.$error }"
                type="password"
                v-model="reTypePassword"
                required
                @input="$v.reTypePassword.$touch()"
              />

              <div v-if="$v.reTypePassword.$error">
                <div class="error-holder">
                  <span> Passwords do not match. Please try again. </span>
                </div>
              </div>
            </div>

            <div class="reset-button text-left">
              <button
                class="button-gemnote button-gemnote--small"
                @click="confirmNewPassword"
              >
                <span>{{ $t('confirm-reset.ui.btn-reset') }}</span>
              </button>
            </div>

            <p class="reroute">
              {{ $t('confirm-reset.ui.have-account?') }}
              <strong>
                <router-link :to="{ name: 'login' }" class="link">{{
                  $t('confirm-reset.ui.login-page')
                }}</router-link>
              </strong>
            </p>
          </form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts } from '../helpers'
import { required, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'ConfirmResetPassword',
  data() {
    return {
      token: null,
      password: '',
      reTypePassword: ''
    }
  },
  validations: {
    password: { required },

    reTypePassword: {
      required,
      sameAs: sameAs(vm => {
        return vm.password
      })
    }
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
    this.token = this.$route.query.token
  },
  computed: {
    successResetPassword() {
      if (this.resetPwdSuccessMessage) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.password = ''
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.reTypePassword = ''
      }
      return this.resetPwdSuccessMessage
    },
    ...mapState({
      resetPwdSuccessMessage: state => state.auth.resetPwdSuccessMessage
    })
  },
  methods: {
    confirmNewPassword() {
      this.$store.dispatch('auth/resetUserPassword', {
        password: this.password,
        reTypePassword: this.reTypePassword,
        token: this.token
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
.message {
  margin-bottom: 3rem;
}

.login {
  border: 1px solid $main-6;
  color: $main-6;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 0.875rem;
  border-radius: 40px;
  padding: 0 1rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

h3 {
  font-size: 2.5rem;
  font-weight: 400;
  text-align: left;
  padding-bottom: 2rem;

  &.success {
    margin-top: 2rem;
    line-height: 52px;
  }
}

.reroute {
  padding-top: 0.75rem;
  font-size: 0.875rem;

  a {
    text-decoration: underline;
  }
}

.error-holder {
  text-align: left;

  span {
    color: #ce3c3c;
    font-weight: 700;
    font-size: 10px;
  }
}

.row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
  grid-template-rows: auto;
  height: 100vh;
}

.left-column {
  background: url('../assets/Gemnote_SignOn_1.png');
  background-size: cover;
  background-position: center;
}

.gemnote-logo {
  text-align: left;
  img {
    height: 4rem;
  }
}

.main-input-form-container {
  padding: 8rem;
}

form {
  margin-top: 3rem;

  .form-group {
    width: 50%;

    &.last {
      margin-bottom: 0.75rem;
    }

    input {
      font-size: 1rem !important;
      font-family: $inter;

      &::placeholder {
        font-weight: 400 !important;
        color: #232220;
        opacity: 0.4;
      }
    }
  }

  .reset-button {
    padding: 1rem 0;
    text-align: left;

    .button-gemnote--small {
      height: 2.5rem;
      width: auto;
      padding: 0 1rem;
    }
  }

  p {
    text-align: left;
  }
}

@media screen and (max-width: 1500px) and (min-width: 900px) {
  .main-input-form-container {
    padding: 6rem;
  }
}

@media (max-width: 1100px) {
  .row {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    transition: 1s ease-in;
  }

  .left-column {
    height: 50vh;
  }

  .right-column {
    height: 50vh;
  }

  .gemnote-logo {
    padding-bottom: 1rem;
  }

  .main-input-form-container {
    padding: 2rem;
  }

  form {
    margin: 0 auto;

    .reset-button {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }

    p {
      margin: 0rem 0rem;
    }
  }
}

@media (max-width: 575.98px) {
  .form-group {
    width: 100% !important;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .form-group {
    width: 100% !important;
  }
}
</style>
